import React from "react";

/**
 * Displays upload progress for multiple files
 *
 * @param {Object} props
 * @param {Object} props.progress - Object with filename keys and status values
 * @returns {JSX.Element|null}
 */
const UploadProgressDisplay = ({ progress }) => {
  if (Object.keys(progress).length === 0) return null;

  return (
    <div className="mt-4 space-y-2">
      {Object.entries(progress).map(([fileName, status]) => (
        <div
          key={fileName}
          className="flex items-center justify-between bg-gray-50 p-2 rounded"
        >
          <span className="text-sm text-gray-700">{fileName}</span>
          <span
            className={`text-sm ${
              status === "Complete"
                ? "text-green-600"
                : status === "Failed"
                ? "text-red-600"
                : "text-blue-600"
            }`}
          >
            {status}
          </span>
        </div>
      ))}
    </div>
  );
};

export default UploadProgressDisplay;
